// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Tab2_style_wrapper__2kfRJ"};